import type { FaireProductEntity } from "../../entity_types/product";

export const p_vrsqsbtkmm: FaireProductEntity = {
  token: "p_vrsqsbtkmm",
  type: "product",
  name: "18K GOLD RHODIUM DIPPED EVIL EYE PENDANT NECKLAC, BPN 00461",
  brandToken: "b_gk6kg6d4dw",
  brandName: "JOIA ACCESSORIES",
  imageUrl:
    "https://cdn.faire.com/fastly/ade6899a89add3e3af47a6ab5e630ea01793f6d5b538e69b5f2f9abc3791d6d7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8f294bd8d6d032a77afcdd4c0b823294b71a12ff6bc880361e84af007bd0db0e.jpeg",
  ],
  priceDollars: 10.39,
  description:
    "18K GOLD RHODIUM DIPPED EVIL EYE PENDANT NECKLACE 18K GOLD dipped Rhodium dipped Hypoallergenic Handmade  Made of Brass Lead & Nickel Free Designed in USA 100% Crafted with you in mind",
  tags: [],
  msrpDollars: 20.79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:29.147Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
